const menus = [
  {
    id: "FM1000",
    pid: "100",
    icon: "basic",
    order: 1,
    pathName: "",
    title: "基础管理",
  },
  {
    id: "FM1001",
    pid: "FM1000",
    icon: "",
    order: 1,
    pathName: "YZSysinfo.Company",
    title: "班级管理",
  },
  {
    id: "FM1002",
    pid: "FM1000",
    icon: "",
    order: 2,
    pathName: "YZSysinfo.Department",
    title: "部门管理",
  },
  {
    id: "FM1003",
    pid: "FM1000",
    icon: "",
    order: 3,
    pathName: "YZSysinfo.Role",
    title: "角色管理",
  },
  {
    id: "FM1004",
    pid: "FM1000",
    icon: "",
    order: 4,
    pathName: "YZSysinfo.UserInfo",
    title: "用户管理",
  },
  // {
  //     id: "FM1005",
  //     pid: "FM1000",
  //     icon: "",
  //     order: 5,
  //     pathName: "YZSysinfo.UserPermission",
  //     title: "用户申请管理",
  // },
  {
    id: "FM1006",
    pid: "FM9000",
    icon: "",
    order: 6,
    pathName: "YZSysinfo.Notice",
    title: "公告中心",
  },
  {
    id: "FM1007",
    pid: "FM9000",
    icon: "",
    order: 7,
    pathName: "YZSysinfo.Slideshow",
    title: "轮播图",
  },
  {
    id: "FM1008",
    pid: "FM1000",
    icon: "",
    order: 8,
    pathName: "YZCourse.Teacher",
    title: "讲师管理",
  },
  {
    id: "FM1009",
    pid: "FM1000",
    icon: "",
    order: 9,
    pathName: "YZSysinfo.UserArchive",
    title: "一人一档",
  },
  {
    id: "FM2000",
    pid: "100",
    icon: "resource",
    order: 5,
    pathName: "",
    title: "资源中心",
  },
  {
    id: "FM2001",
    pid: "FM2000",
    icon: "",
    order: 1,
    pathName: "YZResource.resource_center",
    title: "资源管理",
  },
  // {
  //   id: "FM2002",
  //   pid: "FM2000",
  //   icon: "",
  //   order: 1,
  //   pathName: "YZResource.hazard_basis",
  //   title: "隐患依据",
  // },
  {
    id: "FM3000",
    pid: "100",
    icon: "course",
    order: 7,
    pathName: "",
    title: "课程管理",
  },
  {
    id: "FM3001",
    pid: "FM3000",
    icon: "",
    order: 1,
    pathName: "YZCourse.CourseCenter",
    title: "课程中心",
  },
  {
    id: "FM3002",
    pid: "FM3000",
    icon: "",
    order: 2,
    pathName: "YZCourse.CourseCategory",
    title: "课程分类",
  },
  {
    id: "FM3003",
    pid: "FM3000",
    icon: "",
    order: 3,
    pathName: "YZCourse.CourseRecord",
    title: "课程学习记录",
  },
  {
    id: "FM3004",
    pid: "FM3000",
    icon: "",
    order: 4,
    pathName: "YZCourse.CourseCertificate",
    title: "学习证书",
  },
  {
    id: "FM3005",
    pid: "FM3000",
    icon: "",
    order: 5,
    pathName: "YZCourse.CourseSnap",
    title: "课程学习抓拍记录",
  },
  {
    id: "FM4000",
    pid: "100",
    icon: "question",
    order: 6,
    pathName: "",
    title: "问卷中心",
  },
  {
    id: "FM4001",
    pid: "FM4000",
    icon: "",
    order: 1,
    pathName: "QuestionnaireCenter.QuestionnaireList",
    title: "问卷管理",
  },
  {
    id: "FM4002",
    pid: "FM4000",
    icon: "",
    order: 2,
    pathName: "QuestionnaireCenter.QuestionDataList",
    title: "问卷数据中心",
  },
  {
    id: "FM5000",
    pid: "100",
    icon: "exam",
    order: 8,
    pathName: "",
    title: "考试中心",
  },
  {
    id: "FM5001",
    pid: "FM5000",
    icon: "",
    order: 1,
    pathName: "YZExam.QuestionBank",
    title: "题库管理",
  },
  {
    id: "FM5002",
    pid: "FM5000",
    icon: "",
    order: 2,
    pathName: "YZExam.ExamManagement",
    title: "考试管理",
  },
  {
    id: "FM5003",
    pid: "FM5000",
    icon: "",
    order: 3,
    pathName: "YZExam.ExamDataCenter",
    title: "考试成绩报告",
  },
  {
    id: "FM5004",
    pid: "FM5000",
    icon: "",
    order: 4,
    pathName: "YZExam.ExamReport",
    title: "考试数据中心",
  },
  // {
  //   id: "FM6000",
  //   pid: "100",
  //   icon: "",
  //   order: 2,
  //   pathName: "",
  //   title: "档案数据",
  // },
  /*
  {
    id: "FM6001",
    pid: "FM6000",
    icon: "",
    order: 1,
    pathName: "YZBasic.InjuryUnit",
    title: "工伤单位",
  },
  {
    id: "FM6002",
    pid: "FM6000",
    icon: "",
    order: 2,
    pathName: "YZBasic.InjuryType",
    title: "所属行业",
  },
  {
    id: "FM6003",
    pid: "FM6000",
    icon: "",
    order: 3,
    pathName: "YZBasic.InjurySite",
    title: "受伤部位",
  },
  {
    id: "FM6004",
    pid: "FM6000",
    icon: "",
    order: 4,
    pathName: "YZBasic.InjuryPart",
    title: "受伤类型",
  },
  */
  // {
  //   id: "FM6005",
  //   pid: "FM6000",
  //   icon: "",
  //   order: 5,
  //   pathName: "YZBasic.DministrativeDivisions",
  //   title: "省市",
  // },
  /*
  {
    id: "FM6006",
    pid: "FM6000",
    icon: "",
    order: 6,
    pathName: "YZBasic.OccupationDisease",
    title: "职业病",
  },
  {
    id: "FM7000",
    pid: "100",
    icon: "billcenter",
    order: 3,
    pathName: "",
    title: "单据中心",
  },
  {
    id: "FM7001",
    pid: "FM7000",
    icon: "",
    order: 1,
    pathName: "YZDocomentCenter.InjuryAffirmBill",
    title: "工伤认定单",
  },
  {
    id: "FM7002",
    pid: "FM7000",
    icon: "",
    order: 2,
    pathName: "YZDocomentCenter.InjuryAffirmBill_XY",
    title: "新余市工伤认定单据",
  },
  {
    id: "FM8000",
    pid: "100",
    icon: "analysis",
    order: 4,
    pathName: "",
    title: "大数据分析",
  },
  {
    id: "FM8001",
    pid: "FM8000",
    icon: "",
    order: 1,
    pathName: "YZReport.InjuryDevelopmentTrendAlysis",
    title: "工伤事故发展趋势统计分析",
  },
  {
    id: "FM8002",
    pid: "FM8000",
    icon: "",
    order: 2,
    pathName: "YZReport.InjuryDeadthAlysis",
    title: "年度死亡人数分析",
  },
  {
    id: "FM8003",
    pid: "FM8000",
    icon: "",
    order: 3,
    pathName: "YZReport.InjuryMonthAlysis",
    title: "工伤事故发生月份分析",
  },
  {
    id: "FM8004",
    pid: "FM8000",
    icon: "",
    order: 4,
    pathName: "YZReport.InjuryQuarterAlysis",
    title: "工伤事故季度分析",
  },
  {
    id: "FM8005",
    pid: "FM8000",
    icon: "",
    order: 5,
    pathName: "YZReport.InjuryTypeAlysis",
    title: "工伤事故行业分析",
  },
  {
    id: "FM8006",
    pid: "FM8000",
    icon: "",
    order: 6,
    pathName: "YZReport.InjuryPartAlysis",
    title: "主要伤害类型分析",
  },
  {
    id: "FM8007",
    pid: "FM8000",
    icon: "",
    order: 7,
    pathName: "YZReport.InjurySexAlysis",
    title: "受伤人群性别分析",
  },
  {
    id: "FM8008",
    pid: "FM8000",
    icon: "",
    order: 8,
    pathName: "YZReport.InjuryAgeAlysis",
    title: "年龄阶段分析",
  },
  {
    id: "FM8009",
    pid: "FM8000",
    icon: "",
    order: 9,
    pathName: "YZReport.OccupationalInjuryLevelAlysis",
    title: "工伤等级分析",
  },
  {
    id: "FM8010",
    pid: "FM8000",
    icon: "",
    order: 10,
    pathName: "YZReport.InjurySiteAlysis",
    title: "伤害部位分析",
  },
  {
    id: "FM8011",
    pid: "FM8000",
    icon: "",
    order: 11,
    pathName: "YZReport.InjuryUnitAlysis",
    title: "企业工伤数据分析",
  },
  {
    id: "FM8012",
    pid: "FM8000",
    icon: "",
    order: 12,
    pathName: "YZReport.InjuryOccupationDisease",
    title: "职业病工伤数据分析",
  },
  */
  {
    id: "FM9000",
    pid: "100",
    icon: "system",
    order: 9,
    pathName: "",
    title: "系统管理",
  },
  {
    id: "FM9002",
    pid: "FM9000",
    icon: "",
    order: 2,
    pathName: "YZSysinfo.SystemConfig",
    title: "参数设置",
  },
  {
    id: "FM9003",
    pid: "FM9000",
    icon: "",
    order: 3,
    pathName: "YZNews.NewsCategory",
    title: "宣传分类",
  },
  {
    id: "FM9004",
    pid: "FM9000",
    icon: "",
    order: 4,
    pathName: "YZNews.News",
    title: "宣传专区",
  },
  {
    id: "FM9005",
    pid: "FM9000",
    icon: "",
    order: 5,
    pathName: "YZSysinfo.DataDownload",
    title: "资料下载管理",
  },
  {
    id: "FM9006",
    pid: "FM9000",
    icon: "",
    order: 6,
    pathName: "YZSysinfo.CustomizedZone",
    title: "首页专区",
  },
  {
    id: "FM9007",
    pid: "FM9000",
    icon: "",
    order: 7,
    pathName: "YZSysinfo.AppVersionManagement",
    title: "版本管理",
  },
  {
    id: "FM10000",
    pid: "100",
    icon: "system",
    order: 10,
    pathName: "",
    title: "课程管理"
  },
  {
    id: "FM10001",
    pid: "FM10000",
    icon: "",
    order: 1,
    pathName: "CourseManagement.CourseList",
    title: "课程"
  }
];
export default menus;
